<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="customerNonActive"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="customerForm"
          :redirect-detail="true"
          :show-add-button="false"
          caption="<i class='fa fa-align-justify'></i> Customer Non-Active Listing"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>

    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import loading from "@/templates/Loading.vue";

export default {
  name: "customerNonActive",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      customerNonActive: [],
      listCustomerGroup: [],
      listZone: [],
      listVehicleDelivery: [],
      listOrderTime: [],
      loading: true,
      loadingSubmit: false,
      isNonGT: false,
      fields: [
        { key: "customer_detail", label: "Nama Konsumen", sortable: true },
        { key: "owner_name", label: "Pemilik", sortable: true },
        { key: "contact_number", label: "Nomor Kontak", sortable: true },
        {
          key: "vehicle_delivery_name",
          label: "Kendaraan Yang Mengirim",
          sortable: true
        },
        { key: "order_time_routine_name", label: "Hari Order", sortable: true },
        { key: "dc_name", label: "Distribution Center", sortable: true },
        { key: "bank_account", label: "Bank Account", sortable: true },
        { key: "action", class: "text-center width-80" }
      ],
      customerForm: interfaces.customer
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations() {
    if (this.isNonGT === true) {
      return custom_validation.customer.true;
    } else {
      return custom_validation.customer.false;
    }
  },
  computed: {
    accessLevel() {
      return localStorage.getItem("level") === "1" ? true : false;
    }
  },
  methods: {
    init: function() {
      this.loading = true;

      this.getAllNonActiveCustomer();
      this.getDropdown();
    },
    setSelected: function(event) {
      let temp = this.listCustomerGroup.filter(x => x.value === event);
      this.isNonGT = temp[0].flag === "2" ? true : false;
    },
    getAllNonActiveCustomer: function() {
      this.axios
        .get("web/customer/non-active/all/")
        .then(response => {
          this.customerNonActive = response.data.data;
          // console.log("this.customerNonActive: " + this.customerNonActive);
          // console.log("this.customer: " + this.customer);
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/dropdown-customer/")
        .then(response => {
          this.listCustomerGroup = response.data.customer_group;
          this.listZone = response.data.zone;
          this.listOrderTime = response.data.order_time;
          this.listVehicleDelivery = response.data.vehicle_delivery;
        })
        .catch(error => {})
        .finally(() => {});
    },
    editForm: function() {},
    resetForm: function() {
      for (var a in interfaces.customer) {
        interfaces.customer[a] = null;
      }
      this.customerForm = interfaces.customer;
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style></style>
